import React, {useEffect, useState} from 'react';
import {goToPage, getTechnicianSlotsDeliveries, setSelectedDeliverySlot, reportDWH} from '../StandAlonePurchaseSaleSlice';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {connect} from 'react-redux';
import {ePages} from '../Constants';
import Property from '@episerver/spa-core/Components/Property';
import DatePicker from 'react-datepicker';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import he from 'date-fns/locale/he';
import {getFormatDate, getDayName} from '../../../../utilities/dateUtils';

const TechnicianSlotsPage = (props) => {
  const [date, setDate] = useState(new Date());
  const [availableDates, setAvailableDates] = useState([]);
  const [radioBtnValue, setRadioBtnValue] = useState('');
  const [radioBtns, setRadioBtns] = useState([]);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  useEffect(() => {
    const timeFrom = '09:00';
    const timeDate = getFormatDate(new Date()).replace('/', '-').replace('/', '-');
    const addressData = {
      city: props.form.cityName,
      street: props.form.streetName,
      homeNum: props.form.home,
      slotTimeNoteOrder: 'true',
      slotTimeDate: timeDate, //TODO: figure out what is this
      slotTimeFrom: timeFrom,
    };

    (async () => {
      props.showAppLoader();
      const response = await props.getTechnicianSlotsDeliveries(addressData);
      if (response.payload.returnCode != '00') {
        props.reportDWH({
          actionType: 'Enter Delivery Date Page',
          statusText: 'Ongoing',
          messageText: 'General Error',
        });
      }
      props.hideAppLoader();
    })();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (props.deliveryTimeSlots.length > 0) {
      const availableDates = [...new Set(props.deliveryTimeSlots.map((slt) => new Date(slt.lfdat)))];
      setAvailableDates(availableDates);
      setDate(availableDates[0]);
      setRadioBtns(getSpecificDeliverySlots(availableDates[0]));
    }
  }, [props.deliveryTimeSlots]);

  function handleSelectedDate(date) {
    setDate(date);
    setRadioBtns(getSpecificDeliverySlots(date));
  }

  function getSpecificDeliverySlots(date) {
    const selectedDate = getFormatDate(date);

    const filteredDeliveries = props.deliveryTimeSlots.filter((slt) => {
      const dateSplited = slt.lfdat.split('-');
      const formattedDate = `${dateSplited[2]}/${dateSplited[1]}/${dateSplited[0]}`;
      return formattedDate === selectedDate;
    });

    const deliverySlotsSpecificForThatDate = filteredDeliveries.map((dlv) => {
      const id = dlv.key;
      const label = `${dlv.waitFrom.substring(0, 5)}-${dlv.waitTo.substring(0, 5)}`;
      return {id, label};
    });

    return deliverySlotsSpecificForThatDate;
  }

  function handleSubmit() {
    props.reportDWH({
      actionType: 'Delivery Date Page Btn Click',
      statusText: 'Ongoing',
      messageText: 'Go to Finish Page',
    });
    const isValid = radioBtnValue !== '';
    setShowErrorMsg(!isValid);
    if (isValid) {
      const deliveryTimeSlot = props.deliveryTimeSlots.filter((rd) => rd.key === radioBtnValue)[0];
      props.setSelectedDeliverySlot(deliveryTimeSlot);
      props.goToPage({page: ePages.CHECKOUT_PAGE, percent: '80'});
    }
  }

  return (
    <div className='technician-slots-page'>
      <Property
        className='technician-slots-page__title'
        context={props.context}
        iContent={props.iContent}
        field='deliveryScheduleDeliveryPage'
      />
      <div className='technician-slots-page__date-picker'>
        <div className='datepicker-custom-container p-0 m-0'>
          <DatePicker
            wrapperClassName='datepicker-custom-wrapper'
            calendarClassName='datepicker-custom-calendar'
            locale={he}
            selected={date}
            onChange={(date) => handleSelectedDate(date)}
            includeDates={availableDates}
            inline
          />
        </div>
      </div>
      {showErrorMsg && <p className='error'>יש לבחור זמן לשליחות</p>}
      <div className='technician-slots-page__slots'>
        <span className='technician-slots-page__slots-date-title'>{`${getFormatDate(date)
          .replace('/', '.')
          .replace('/', '.')}  ${getDayName(date)}`}</span>
        <div className='technician-slots-page__slots-holder'>
          {radioBtns.length > 0
            ? radioBtns.map((btn) => {
                return (
                  <div key={btn.id} className='technician-slots-page__slot-holder'>
                    <RadioInput
                      checked={radioBtnValue == btn.id}
                      id={btn.id}
                      name='slot-time'
                      value={btn.id}
                      onChange={(e) => setRadioBtnValue(e.currentTarget.value)}
                    />
                    <span className={`technician-slots-page__slot-time ${radioBtnValue == btn.id ? 'bold' : ''}`}>{btn.label}</span>
                  </div>
                );
              })
            : 'לא נמצאו זמני שליחות'}
        </div>
      </div>
      <BtnSubmit
        text={`${props.deliveryScheduleDeliveryButtonText === '' ? 'בחירה וסיום' : props.deliveryScheduleDeliveryButtonText}`}
        onclick={() => handleSubmit()}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    iContent: state.standAlonePurchaseSaleBlock?.epiContent?.iContent,
    deliveryButtonText: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryButtonText?.value ?? '',
    deliveryScheduleDeliveryButtonText:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryScheduleDeliveryButtonText?.value ?? '',
    deliveryTimeSlots: state.standAlonePurchaseSaleBlock?.deliveryTimeSlots ?? '',
    form: state.standAlonePurchaseSaleBlock?.form,

    //other states
    isLoading: state.loader?.isLoading,
  };
};

const mapDispatchToProps = {
  goToPage,
  getTechnicianSlotsDeliveries,
  setSelectedDeliverySlot,
  showAppLoader,
  hideAppLoader,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianSlotsPage);
